import { useState } from "react";
import { Link } from "react-router-dom";
import { API_URL, authFetch } from "../../utils/auth";

function statusClass(status) {
  return `delivery-status delivery-status-${status || "pending"}`;
}

export default function ClientActionItems({ items = [], onUpdated }) {
  const [notes, setNotes] = useState({});
  const [files, setFiles] = useState({});
  const [busyId, setBusyId] = useState(null);
  const [message, setMessage] = useState("");

  async function updateItem(item, action) {
    setBusyId(item.id);
    setMessage("");
    const body = new FormData();
    body.append("client_note", notes[item.id] || "");
    const selectedFile = files[item.id];
    if (selectedFile) body.append("file", selectedFile);
    try {
      const response = await authFetch(`${API_URL}/client/action-items/${item.id}/${action}/`, { method: "POST", body });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to update action item.");
      setNotes((current) => ({ ...current, [item.id]: "" }));
      setFiles((current) => ({ ...current, [item.id]: null }));
      setMessage(action === "complete" ? "Action item completed." : "Action item submitted.");
      onUpdated?.(data);
    } catch (err) {
      setMessage(err.message || "Unable to update action item.");
    } finally {
      setBusyId(null);
    }
  }

  return (
    <div className="client-card action-card">
      <div className="section-heading-row">
        <div>
          <h2>Action Items</h2>
          <p>Items SCD needs from you to keep the project moving.</p>
        </div>
        {items.length > 0 && <span className="count-pill">{items.length}</span>}
      </div>
      {message && <p className="form-status-text">{message}</p>}
      {items.length === 0 ? <p className="empty-copy">No outstanding action items.</p> : (
        <div className="action-list">
          {items.map((task) => (
            <article className="action-item" id={`action-item-${task.id}`} key={task.id}>
              <div className="action-item-head">
                <div>
                  <h3>{task.title}</h3>
                  <div className="action-badges">
                    <span className={statusClass(task.status)}>{task.status_label || task.status}</span>
                    {task.is_required && <span className="delivery-chip">Required</span>}
                    {task.requires_file && <span className="delivery-chip">File needed</span>}
                    {task.is_overdue && <span className="delivery-chip danger">Overdue</span>}
                  </div>
                </div>
                {task.due_date && <small>Due {new Date(task.due_date).toLocaleDateString()}</small>}
              </div>
              {task.instructions && <p>{task.instructions}</p>}
              {task.staff_note && task.status === "needs_changes" && <p className="staff-note">SCD note: {task.staff_note}</p>}
              {(task.files || []).length > 0 && (
                <div className="linked-files">
                  {(task.files || []).map((file) => <a key={file.id} href={file.download_url || file.url} target="_blank" rel="noreferrer">{file.title}</a>)}
                </div>
              )}
              {(task.can_submit || task.can_complete) && (
                <div className="action-form">
                  <textarea
                    value={notes[task.id] || ""}
                    onChange={(event) => setNotes((current) => ({ ...current, [task.id]: event.target.value }))}
                    placeholder="Add an optional note for SCD"
                  />
                  {task.requires_file && <input type="file" onChange={(event) => setFiles((current) => ({ ...current, [task.id]: event.target.files?.[0] || null }))} />}
                  <div className="action-buttons">
                    {task.can_submit && <button type="button" onClick={() => updateItem(task, "submit")} disabled={busyId === task.id}>{busyId === task.id ? "Submitting..." : "Submit"}</button>}
                    {task.can_complete && <button type="button" className="secondary-action" onClick={() => updateItem(task, "complete")} disabled={busyId === task.id}>{busyId === task.id ? "Saving..." : "Mark Complete"}</button>}
                    {task.route && <Link to={task.route}>Open project</Link>}
                  </div>
                </div>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}